<div class="iframe-container">
  <iframe *ngIf="_data"
    name="quill-iframe"
    [id]="_data.id"
    [title]="_data.title"
    [width]="iframeDimensions.width"
    [height]="iframeDimensions.height"
    [srcdoc]="_data.data">
  </iframe>
</div>
